














import Vue from 'vue';
import { Modal, ModalMixin } from 'mycorems-app-shared';
import { Client, ModalElement } from '@/types';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  computed: {
    title(): string {
      return `CM Report Credits for ${this.client.name}`;
    },
  },
  methods: {
    ok(): void {
      this.$emit('ok');
      (this.$refs.modal as ModalElement).hide();
    },
  },
  components: {
    modal: Modal,
  },
});
